import { render, staticRenderFns } from "./print2Item.vue?vue&type=template&id=178101f4"
import script from "./print2Item.vue?vue&type=script&lang=js"
export * from "./print2Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports